const n = {
  toView(r) {
    return r.toString();
  },
  fromView(r) {
    if (typeof r == "number")
      return r;
    const t = parseFloat(r);
    return isNaN(t) ? r : t;
  }
};
export {
  n as NumberStringConverter
};
